import { Box, Button, Container, Typography } from "@mui/material";
import React from "react";
import arrow from "../../assets/images/website/launcharrow.png";
import owner from "../../assets/images/website/ownership4.png";
import { useNavigate } from "react-router-dom";

function OwnershipSection() {
  const navigate = useNavigate()
  return (
    <React.Fragment>
      <Box
        sx={{ backgroundColor: "#E63B1F", padding: { xs: '80px 0px', lg: "200px 0px" } }}
        className="ownership_section"
      >
        <Container maxWidth="xl">
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              flexDirection: { xs: 'column', lg: 'row' }
            }}
          >
            <Box sx={{ width: { xs: '100%', lg: "50%" } }}>
              <Typography
                sx={{
                  color: "#fff",
                  fontWeight: 700,
                  fontFamily: '"Inter", sans-serif',
                  fontSize: { xs: 36, lg: 54 },
                  lineHeight: { xs: '44px', lg: "65px" },
                  maxWidth: '500px',
                  margin: { xs: 'auto', lg: 0 },
                  textAlign: { xs: 'center', lg: 'start' }
                }}
              >
                Why Povego
              </Typography>
              <Typography
                sx={{
                  color: "#fff",
                  fontWeight: 400,
                  fontFamily: '"Inter", sans-serif',
                  fontSize: { xs: 18, lg: 22 },
                  padding: "24px 0px 60px",
                  textAlign: { xs: 'center', lg: 'start' }
                }}
              >
                Our advantages and what makes us different from competitors.<br/><br/>
                There are many reasons for you to choose Povego. First of all, our security priority, which stores your funds in cold wallets and protects them with multi-layer security measures, keeps your investments safe.<br/><br/>
                Thanks to our user-friendly interface that appeals to both beginners and professionals, you can trade quickly and easily. By offering a wide range of cryptocurrencies, we provide many investment opportunities from popular tokens to innovative projects. While offering the chance to obtain maximum earnings with our competitive commission rates and regular campaigns, we ensure you save time with our fast transaction and withdrawal processes. We are always by our users' side with Turkish 24/7 customer support and payment methods specific to Türkiye. You are at the right address for a reliable, fast, and user-oriented crypto investment experience.
              </Typography>
              <Box sx={{ display: 'flex', justifyContent: { xs: 'center', lg: 'start' } }}>
                
              </Box>
            </Box>
            <Box sx={{ width: { xs: '100%', md: '45%' }, marginTop: { xs: '60px', lg: '0px' } }}>
              <img src={owner} alt="owner" style={{ width: '100%' }}></img>
            </Box>
          </Box>
        </Container>
      </Box>
    </React.Fragment>
  );
}

export default OwnershipSection;
